import { useHomeSecurity } from '@contexts/HomeSecurityContext/HomeSecurityContext';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const useWithdrawalPageVM = () => {
    const navigate = useNavigate();
    const { handleAddPassedModule, worksiteId } = useHomeSecurity();

    useEffect(() => {
        if (!worksiteId) {
            navigate('/sante-securite/home-security');
        }
    }, [worksiteId, navigate]);

    const handleNext = () => {
        navigate('/sante-securite/home-security/menu');
        handleAddPassedModule('withdrawal');
        return;
    };

    return {
        handleNext
    };
};
